module.exports = "<div class=\"barcode-container\">\n  <app-barcode [(values)]=\"values\"></app-barcode>\n</div>\n"